import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgPageNotFound(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M70.411 43.2a3.352 3.352 0 0 0-6.704 0v12.198a3.352 3.352 0 1 0 6.704 0V43.2ZM61.522 60.395l2.78 1.254L47.81 98.016a1.528 1.528 0 0 1-2.78-1.265l16.492-36.367v.01ZM72.974 60.395l-2.78 1.254 16.492 36.367a1.528 1.528 0 0 0 2.022.757 1.528 1.528 0 0 0 .757-2.022l-16.49-36.367v.01Z"
        fill="#599F40"
      />
      <path
        d="M65.511 57.832h3.245v39.47a1.62 1.62 0 0 1-1.623 1.622 1.62 1.62 0 0 1-1.622-1.622v-39.47Z"
        fill="#599F40"
      />
      <path
        d="M74.931 55.701H59.803a.973.973 0 0 0-.973.974v3.536c0 .537.435.973.973.973h15.129a.973.973 0 0 0 .973-.973v-3.536a.973.973 0 0 0-.974-.974Z"
        fill="#599F40"
      />
      <path
        d="M75.905 58.134v3.299a.97.97 0 0 1-.974.973H59.803a.97.97 0 0 1-.973-.973v-3.299h17.075ZM64.983 51.127a3.355 3.355 0 0 1 3.352-3.352 3.355 3.355 0 0 1 3.352 3.352 3.355 3.355 0 0 1-3.352 3.352 3.355 3.355 0 0 1-3.352-3.352Z"
        fill="#78B441"
      />
      <path
        d="M60.657 50.986a3.355 3.355 0 0 1 3.352-3.352 3.355 3.355 0 0 1 3.353 3.352 3.355 3.355 0 0 1-3.353 3.353 3.355 3.355 0 0 1-3.352-3.352Z"
        fill="#599F40"
      />
      <path
        d="m34.844 41.319 1.536 5.71-8.63 2.314a.973.973 0 0 1-1.19-.692l-1.026-3.829a.973.973 0 0 1 .692-1.189l8.63-2.314h-.012Z"
        fill="#78B441"
      />
      <path
        d="m50.287 34.484 2.811 10.5-16.015 4.294a1.632 1.632 0 0 1-1.99-1.146l-1.968-7.365a1.632 1.632 0 0 1 1.146-1.99l16.016-4.293Z"
        fill="#599F40"
      />
      <path
        d="M86.2 38.226a7.948 7.948 0 1 0 0-15.896 7.948 7.948 0 0 0 0 15.896Z"
        fill="#CAE8DF"
      />
      <path
        d="m82.296 22.492 4.336 16.177-33.75 9.04a1.632 1.632 0 0 1-1.99-1.145L47.4 33.51a1.632 1.632 0 0 1 1.147-1.99l33.75-9.04v.01Z"
        fill="#78B441"
      />
      <path
        d="M83.874 19.659a.973.973 0 0 1 1.19.692l4.996 18.654a.973.973 0 0 1-.692 1.19l-2.541.68a.973.973 0 0 1-1.19-.692L80.641 21.53a.973.973 0 0 1 .692-1.19l2.541-.68Z"
        fill="#599F40"
      />
      <path
        d="M66.681 51.106a2.499 2.499 0 0 0-.204-.994 2.416 2.416 0 0 0-.546-.82 2.583 2.583 0 0 0-.837-.553 2.497 2.497 0 0 0-.976-.197.8.8 0 1 1 0-1.6c.549 0 1.087.108 1.597.323.497.209.953.502 1.347.895.381.381.691.835.896 1.348.215.51.323 1.048.323 1.598 0 .549-.108 1.087-.323 1.596-.209.497-.502.954-.896 1.348-.381.381-.834.69-1.348.895l-.015.008h-.001a4.095 4.095 0 0 1-1.58.316.8.8 0 0 1 0-1.6c.337 0 .664-.066.976-.197l.017-.007c.301-.12.578-.304.82-.546.234-.233.416-.512.553-.837a2.5 2.5 0 0 0 .197-.976ZM35 100.425a.8.8 0 1 1 0-1.6h59.5a.8.8 0 1 1 0 1.6H35Zm-9.5 0a.8.8 0 1 1 0-1.6h4.875a.8.8 0 0 1 0 1.6H25.5Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgPageNotFound)
